import React from "react";
import { useNavigate } from "react-router-dom";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useLogin } from "../../store/backend/useLogin";
import useAuth from "../../hooks/useAuth";
import Loader from "../../Shared/Loader/Loader";
import { ErrorMessage, Heading1, PrimaryButton, Textfield } from "widgets";
import { getUamIdOfLoggedInUser } from "utils/tokenUtils";

import styles from "./Login.module.scss";

const handleOnSuccessLogin = (data, authLogin, navigate, mobile) => {
  authLogin(data.accessToken);
  localStorage.setItem("admissionNumber", data.admission_number);
  localStorage.setItem("sales_person_id", data.crnId);
  localStorage.setItem("roles", data.roles);
  const salesPersonUamId = getUamIdOfLoggedInUser();
  localStorage.setItem("salesPersonUamId", salesPersonUamId);
  localStorage.setItem("phoneNumber", mobile);
  navigate("/homePage");
};

const Login = () => {
  const navigate = useNavigate();
  const { login: authLogin } = useAuth();

  const { mutate: login, isPending, isError, error } = useLogin();

  return (
    <Formik
      initialValues={{
        mobile: "",
        password: "",
      }}
      validationSchema={Yup.object({
        mobile: Yup.string()
          .required("Mobile number is required")
          .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits"),
        password: Yup.string()
          .required("Password is required")
          .min(6, "Password must be at least 6 characters"),
      })}
      onSubmit={(values) => {
        login(values, {
          onSuccess: (data) => {
            handleOnSuccessLogin(data, authLogin, navigate, values.mobile);
          },
        });
      }}
    >
      {({ values, setFieldValue, handleSubmit, isValid, errors }) => (
        <Form onSubmit={handleSubmit} autoComplete="off">
          <div className={styles.loginFormContainer}>
            <Heading1 heading="Login" />
            <div>
              <Textfield
                id="mobile"
                label="Mobile"
                type="text"
                value={values.mobile}
                handleOnChange={(event) =>
                  setFieldValue("mobile", event.target.value)
                }
              />
              {errors.mobile && <ErrorMessage>{errors.mobile}</ErrorMessage>}
            </div>
            <div>
              <Textfield
                id="password"
                label="Password"
                type="password"
                value={values.password}
                handleOnChange={(event) =>
                  setFieldValue("password", event.target.value)
                }
              />
              {errors.mobile && <ErrorMessage>{errors.password}</ErrorMessage>}
            </div>
            {isError && (
              <ErrorMessage className={styles.errorMessage}>
                {error.message || "Unable to log in"}
              </ErrorMessage>
            )}
            <div className={styles.btnContainer}>
              <PrimaryButton type="submit" disabled={isPending || !isValid}>
                {isPending ? <Loader /> : "Login"}
              </PrimaryButton>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default Login;
